import React, { createContext, useContext } from "react";

import useWhatsApps from "../../hooks/useWhatsApps";
import { shouldLoadWhatsApps } from "../../hooks/useWhatsApps/loadPolicy.mjs";
import { AuthContext } from "../Auth/AuthContext";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
	const { loading: authLoading, isAuth, user } = useContext(AuthContext);
	const enabled = shouldLoadWhatsApps({
		authLoading,
		isAuth,
		userId: user?.id,
	});
	const { loading, whatsApps } = useWhatsApps({
		enabled,
		sessionKey: user?.id || "anonymous",
	});

	return (
		<WhatsAppsContext.Provider value={{ whatsApps, loading }}>
			{children}
		</WhatsAppsContext.Provider>
	);
};

export { WhatsAppsContext, WhatsAppsProvider };
